/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { Row, Col } from "components/Grid";
import Label from 'components/Form/Label';
import * as yup from 'yup';
import Layout from 'components/Layout';
import SubTitle from 'components/SubTitle';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import FileModal from 'components/FileModal';
import TextField from 'components/Form/TextField';
import CheckBox from "components/Form/CheckBox";
import Colors from "constants/Colors";
import { LostCancelButton } from 'components/index';

import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Scrollbox, Footer, ButtonContent, Title } from './styles';
import InputField from 'components/Form/InputField';
import { TextEditorBox } from 'components/index';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import { useHeaderNbi, useDocument, useListClientContacts, useSentEmailClient } from 'services/QuoteService'; 
import { useOperationInfo } from 'services/OperationService'

export default function SendNbi(props) {

  const loading = useContext(GlobalLoaderContext);
  const [summary, setSummary] = useState({});
  const [insurers, setInsurers] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [file, setFile] = useState();
  const [historymsg, setHistorymsg] = useState([]);
  const [isBound, setIsBound] = useState(false);

  const formik = useRef(null);
  const history = useHistory();
  const authContext = useContext(GlobalAuthContext);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useDocumentData,
    loading: useDocumentLoading,
    error: useDocumentError,
    status: useDocumentStatus,
    request: useDocumentRequest,
  } = useDocument();

  const {
    data: useListClientContactsData,
    loading: useListClientContactsLoading,
    error: useListClientContactsError,
    status: useListClientContactsStatus,
    request: useListClientContactsRequest,
  } = useListClientContacts(props.match.params.idOperation);

  const {
    data: useSentEmailClientData,
    loading: useSentEmailClientLoading,
    error: useSentEmailClientError,
    status: useSentEmailClientStatus,
    request: useSentEmailClientRequest,
  } = useSentEmailClient();

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useDocumentLoading || useListClientContactsLoading || useSentEmailClientLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useDocumentLoading, useListClientContactsLoading, useSentEmailClientLoading]);

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };

  function handleFile() {
    useDocumentRequest({idOperation: props.match.params.idOperation, idTemplate: 4}, null).then((a) => {
        if (a.status !== 200) {
            mc.error(`There was an error while fetching your data: ${handleFile.name}`);
            history.goBack();
            return;
        } else {
            setFile(a.data);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });

  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);

        if (formik.current) {
          formik.current?.setFieldValue('nbiClientSubjectMessage', data.ret_value.nbiClientSubjectMessage || '');
          formik.current?.setFieldValue('additionalNbiClientSubjectivity', data.ret_value.additionalNbiClientSubjectivity || '');
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleSelect(insurer) {
    const contact = { idContact: insurer.idContact, email: insurer.email };

    const alreadySelected = selectedItems.findIndex((item) => item.email === insurer.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.email !== insurer.email);
      setSelectedItems(filteredItems);
    } else {
      setSelectedItems([...selectedItems, contact]);
    };
  };

  function listContacts() {
    useListClientContactsRequest().then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        if (data.ret_value.length >= 1) {
          setInsurers(data.ret_value);
          console.log(data.ret_value);
        }

      })
      .catch((error) => {
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  };

  const listItems = insurers.map((insurer) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
        <Col style={{ flexDirection: "row", display: "flex" }}>
          <label>
            <CheckBox
              onChange={() => { handleSelect(insurer) }}
              checked={selectedItems.find((item) => item.email === insurer.email) ? true : false}
              disabled={insurer.existContact ? true : false || isBound}
            />
          </label>
          <Label textColor={insurer?.existContact ? Colors.GRAY[3] : null}>
            {insurer.nameContact}
          </Label>
        </Col>
        <Col md={8} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
          <Label textColor={insurer?.existContact ? Colors.GRAY[3] : null}>{insurer.email}</Label>
        </Col>
      </Row>
    </>
  ));

  const handleSubmit = (e) => {
    console.log(selectedItems, e)
    if (selectedItems.length == 0) {
      mc.error('Please, select at least one contact');
      return;
    }
    let body = {
      idOperation: props.match.params.idOperation,
      contacts: [...selectedItems]
    }
    //fitinsur.setAuthToken('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOjExMDAsInVzZXJuYW1lIjoicG9jX3RleGVsQGZpdGluc3VyLmNvbS5iciIsInBlcnNvbmlkIjoxMDE3MDMsImZpcnN0TmFtZSI6IlRFWEVMIiwibGFzdE5hbWUiOiJGSU5BTkNFIExJTUlURUQiLCJpZFBlcnNvblJvb3QiOjEwMTcwMywidXNlcmFkbWluIjpmYWxzZSwiZW51bVByb2ZpbGUiOjAsImV4cCI6MTU5OTA1ODY4NiwiaWF0IjoxNTk4NjI2Njg2fQ.QisKhiCo2gbtD22c36AsqgpNw2ZMqyMfwmpoKbmc0Kg');
    useSentEmailClientRequest({...body}).then(({data: res}) => {
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details);
          return;
        }
        history.push('/list');

      });
  }

  useEffect(() => {
    let v = handleHistoryMessage()
    if (formik.current) {
      formik.current?.setFieldValue('dealAnalisysInformation', v)

    }

  }, [historymsg])


  const handleOperationInfo = () => {
    useOperationInfoRequest().then(({data}) => {
        setIsBound(data.isBound || false)
      })
  }

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
      
    handleFile();
    handleSummary();
    listContacts();
    handleOperationInfo();
  }, []);

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary?.nmObligor ? summary?.nmObligor : "Broking name"} subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <Scrollbox>
        <BrokingSummary data={summary} />
        <ContentCard title="SEND NBI" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
          <Title>TO</Title>
          {listItems}
          <Formik
            innerRef={formik}
            initialValues={{
              nbiClientSubjectMessage: '',
              additionalNbiClientSubjectivity: '',
              dealAnalisysInformation: ''
            }}
            onSubmit={handleSubmit}
          >
            {formikProps => (
              <Form>
                <Row style={{ marginTop: "20px"}}>
                
                </Row>
                <Row>
                  <Col>
                    <TextEditorBox
                      label='NBI Message - (External)'
                      name='nbiClientSubjectMessage'
                      initialValue={formikProps.values.nbiClientSubjectMessage}
                      disabled
                    />

                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextEditorBox
                      label='Additional subjectivities or questions'
                      name='additionalNbiClientSubjectivity'
                      initialValue={formikProps.values.additionalNbiClientSubjectivity}
                      disabled
                    />
                  </Col>
                </Row>
                <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                <Row>
                  <Col>
                    <Field
                      readOnly
                      label={'Deal Analysis Information'}
                      name={'dealAnalisysInformation'}
                      value={formikProps.values.dealAnalisysInformation}
                      onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                      component={TextField}
                    />

                  </Col>
                </Row>
                <Footer>
                  <ButtonContainer>
                    <Button forth onClick={() => { history.goBack() }}>&lt; Back</Button>
                    <HasPermission permission={!isBound}>
                      <RenderButtons idOperation={props.match?.params?.idOperation}>
                        <ButtonContent>
                          <div style={{ marginTop: "5px" }} >
                            <LostCancelButton idOperation={props.match?.params?.idOperation} />
                          </div>
                          <Button primary type='submit' style={{ marginLeft: "10px", marginTop: "5px" }} >
                            SEND
                          </Button>
                        </ButtonContent>
                      </RenderButtons>
                    </HasPermission>
                  </ButtonContainer>
                </Footer>
              </Form>
            )}
          </Formik>
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}
